import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const PerformerCard = ({ song, rank, isTop }) => {
  const color = isTop
    ? 'bg-emerald-500/10 border-emerald-500/20' :'bg-red-500/10 border-red-500/20';
  const rateColor = isTop ? 'text-emerald-400' : 'text-red-400';
  const Icon = isTop ? TrendingUp : TrendingDown;

  return (
    <div className={`flex items-center gap-3 p-3.5 rounded-xl border ${color}`}>
      <span className="text-xs text-white/30 font-mono w-4 flex-shrink-0">{rank}</span>
      <div className="flex-1 min-w-0">
        <p className="text-white text-sm font-medium truncate">{song?.songTitle}</p>
        <p className="text-white/40 text-xs mt-0.5">{song?.totalViews} views</p>
      </div>
      <div className="flex items-center gap-1.5 flex-shrink-0">
        <Icon className={`w-3.5 h-3.5 ${rateColor}`} />
        <span className={`text-sm font-bold font-mono ${rateColor}`}>{song?.overallCompletionRate}%</span>
      </div>
    </div>
  );
};

const TopBottomPerformers = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[0, 1]?.map(i => (
          <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-5">
            <div className="h-5 w-36 bg-white/10 rounded animate-pulse mb-4" />
            {[...Array(5)]?.map((_, j) => (
              <div key={j} className="h-12 bg-white/5 rounded-xl animate-pulse mb-2" />
            ))}
          </div>
        ))}
      </div>
    );
  }

  const top = data?.top || [];
  const bottom = data?.bottom || [];

  const isEmpty = top?.length === 0 && bottom?.length === 0;

  if (isEmpty) {
    return (
      <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center">
        <p className="text-white/40 text-sm">Not enough data to rank performers. Songs need at least 3 views.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Top performers */}
      <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
        <div className="flex items-center gap-2 mb-4">
          <TrendingUp className="w-4 h-4 text-emerald-400" />
          <h3 className="text-white font-semibold text-base">Top Performers</h3>
          <span className="text-xs text-white/30 ml-auto">by completion rate</span>
        </div>
        {top?.length === 0 ? (
          <p className="text-white/30 text-sm text-center py-4">No data</p>
        ) : (
          <div className="space-y-2">
            {top?.map((song, i) => (
              <PerformerCard key={song?.songId} song={song} rank={i + 1} isTop={true} />
            ))}
          </div>
        )}
      </div>
      {/* Bottom performers */}
      <div className="bg-white/5 border border-white/10 rounded-2xl p-5">
        <div className="flex items-center gap-2 mb-4">
          <TrendingDown className="w-4 h-4 text-red-400" />
          <h3 className="text-white font-semibold text-base">Needs Attention</h3>
          <span className="text-xs text-white/30 ml-auto">lowest completion rates</span>
        </div>
        {bottom?.length === 0 ? (
          <p className="text-white/30 text-sm text-center py-4">No data</p>
        ) : (
          <div className="space-y-2">
            {bottom?.map((song, i) => (
              <PerformerCard key={song?.songId} song={song} rank={i + 1} isTop={false} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TopBottomPerformers;
